import useFriendApplications from '@/hooks/users/use-friend-applications';
import { useConversationSessionStore } from '@/stores/conversation-session';

export default function useFriendRequestCount() {
  const { data } = useFriendApplications();

  const markAllAsRead = () => {
    const applicationIds = data?.applications.map((app) => app.id) ?? [];
    useConversationSessionStore.getState().setLastReadFriendRequestId(Math.max(...applicationIds));
  };

  return {
    friendRequestCount: data?.unreadCount ?? 0,
    markAllAsRead,
  };
}
